import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import VConsole from 'vconsole';
import VConsoleOutputLogsPlugin from './utils/plugins/VConsoleOutputLogsPlugin';

// Initialize VConsole
const vConsole = new VConsole({
  theme: 'dark',
  maxLogNumber: 1000
});

console.log('[VCONSOLE] vConsole initialized');

// Create the output log plugin instance AFTER vConsole is ready
// The plugin will add "Copy Logs" and "Download Logs" buttons to the Log tab
setTimeout(() => {
  const outputLogPlugin = new VConsoleOutputLogsPlugin(vConsole);
  console.log('[VCONSOLE] OutputLogPlugin initialized');
}, 500);

// Prevent "connectCallback is not defined" from the DJI Bridge native layer
// during the gap between login navigating and dashboard mounting.
// The dashboard overwrites these with real handlers in its useEffect.
window.connectCallback = window.connectCallback || function () {};
window.wsConnectCallback = window.wsConnectCallback || function () {};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 